/** @format */

import { isErrorResponse, createBooking } from '../../api/api';
import { action, thunk } from 'easy-peasy';

const paymentModel = {
	error: null,
	ResultUrl: null,

	createBooking: thunk(async (actions, booking) => {
		var request = {
			travelOut: booking.travelOut,
			contactPerson: booking.contactPerson,
		};

		const task = await createBooking(request);
		const res = await task;

		if (isErrorResponse(res)) {
			actions.setError(res);
		} else if (isErrorResponse(res.error)) {
			actions.setError(res.error);
		} else {
			actions.setResultUrl(`/Result/${res.booking.bookingGuid}`);
		}
	}),
	setError: action((state, error) => {
		state.error = error;
	}),
	setResultUrl: action((state, url) => {
		state.ResultUrl = url;
	}),
	reset: action((state) => {
		state.error = null;
		state.ResultUrl = null;
	}),
};

export default paymentModel;
